export const transcriptions = [
  {
    image: require('./images/small/chanting (A Set of Chants, 1819).jpg'),
    title: 'Chanting',
    titleStr: 'Chanting',
    filePath: require('./files/CHANTING.pdf'),
    alt: 'Chanting',
    imageLarge: require('./images/large/chanting (A Set of Chants, 1819)--large.jpg'),
    // caption:
    //   'About 1802 the first movement toward chanting was made by the Rev. William A. Smith...',
    keywords: 'bass viol',
  },
  {
    image: require('./images/small/choir size.jpg'),
    title: 'Choir Size',
    titleStr: 'Choir Size',
    filePath: require('./files/CHOIR SIZE.pdf'),
    alt: 'Choir Size',
    imageLarge: require('./images/large/choir size--large.jpg'),
    // caption:
    //   'Before the introduction of the viol and the flute and the worldly fiddle, ‘the only instrumental music,’ says the same writer [Rev. Theodore J. Holmes], ‘came from the pitch-pipe in the hands of the leader...',
  },
  {
    image: require('./images/small/discord at meeting (Brownson 1783).jpg'),
    title: 'Discord at Meeting',
    titleStr: 'Discord at Meeting',
    filePath: require('./files/DISCORD AT MEETING.pdf'),
    alt: 'Discord at Meeting',
    imageLarge: require('./images/large/discord at meeting (Brownson 1783)--large.jpg'),
    // caption:
    //   'If space permitted, it might be amusing to refer to some of the matters upon which the public mind was agitated at different times in the Colony and Province...',
  },
  {
    image: require('./images/small/financial support for music in church (AAS, source unknown).jpg'),
    title: 'Financial Support for Music in Church',
    titleStr: 'Financial Support for Music in Church',
    filePath: require('./files/FINANCIAL SUPPORT FOR MUSIC IN CHURCH.pdf'),
    alt: 'Financial Support for Music in Church',
    imageLarge: require('./images/large/financial support for music in church (AAS, source unknown)--large.jpg'),
    // caption:
    //   'The favor in which the choir was held was also manifested by several appropriations of money for their benefit, which were expended in the maintenance of singing-schools...',
  },
  {
    image: require('./images/small/instruments, pitch pipes (Brownson 1783).jpg'),
    title: 'Instruments, Pitch Pipes',
    titleStr: 'Instruments, Pitch Pipes',
    filePath: require('./files/INSTRUMENTS, PITCH PIPES.pdf'),
    alt: 'Instruments, Pitch Pipes',
    imageLarge: require('./images/large/instruments, pitch pipes (Brownson 1783)--large.jpg'),
    // caption:
    //   'In the early days of the New England colonies the violin, violoncello, bass viol and flute were for the most part the instruments in use, both in religious and secular circles.',
  },
  {
    image: require('./images/small/lining out, musical illiteracy, textual literacy.jpg'),
    title: 'Lining Out, Musical Illiteracy, Textual Literacy',
    titleStr: 'Lining Out, Musical Illiteracy, Textual Literacy',
    filePath: require('./files/LINING OUT, MUSICAL ILLITERACY, TEXTUAL LITERACY.pdf'),
    alt: 'Lining Out, Musical Illiteracy, Textual Literacy',
    imageLarge: require('./images/large/lining out, musical illiteracy, textual literacy--large.jpg'),
    // caption:
    //   'Farewell, Litchfield and Goshen, a country of storm and winter and frightful cold and snow, and of hardy, active, reading, thinking, intelligent men...',
  },
  {
    image: require('./images/small/meetinghouses (Turner, ME).jpg'),
    title: 'Meetinghouses',
    titleStr: 'Meetinghouses',
    filePath: require('./files/MEETINGHOUSES.pdf'),
    alt: 'Meetinghouses',
    imageLarge: require('./images/large/meetinghouses (Turner, ME)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/music in the meetinghouse (Brownson 1783).jpg'),
    title: 'Music in the Meetinghouse',
    titleStr: 'Music in the Meetinghouse',
    filePath: require('./files/MUSIC IN THE MEETINGHOUSE.pdf'),
    alt: 'Music in the Meetinghouse',
    imageLarge: require('./images/large/music in the meetinghouse (Brownson 1783)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/musical families (John Hay Library, Holden, The Union Harmony vol. I, 2nd ed. (1796)).jpg'),
    title: 'Musical Families',
    titleStr: 'Musical Families',
    filePath: require('./files/MUSICAL FAMILIES.pdf'),
    alt: 'Musical Families',
    imageLarge: require('./images/large/musical families (John Hay Library, Holden, The Union Harmony vol. I, 2nd ed. (1796))--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/musical repertory (CRUCIFIXION) .jpg'),
    title: 'Musical Repertory, General Comments on Psalmody',
    titleStr: 'Musical Repertory, General Comments on Psalmody',
    filePath: require('./files/MUSICAL REPERTORY, GENERAL COMMENTS ON PSALMODY.pdf'),
    alt: 'Musical Repertory, General Comments on Psalmody',
    imageLarge: require('./images/large/musical repertory (CRUCIFIXION)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/musical societies.jpg'),
    title: 'Musical Societies',
    titleStr: 'Musical Societies',
    filePath: require('./files/MUSICAL SOCIETIES (occasionally = church choirs).pdf'),
    alt: 'Musical Societies',
    imageLarge: require('./images/large/musical societies--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/order of service.jpg'),
    title: 'Order of Service',
    titleStr: 'Order of Service',
    filePath: require('./files/ORDER OF SERVICE.pdf'),
    alt: 'Order of Service',
    imageLarge: require('./images/large/order of service--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/reading Scriptures in service.jpg'),
    title: 'Reading Scriptures (including Psalms) in Service',
    titleStr: 'Reading Scriptures (including Psalms) in Service',
    filePath: require('./files/READING SCRIPTURES (including Psalms) IN SERVICE.pdf'),
    alt: 'Reading Scriptures (including Psalms) in Service',
    imageLarge: require('./images/large/reading Scriptures in service--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/references to psalmodists (Stone portrait).jpg'),
    title: 'References to Psalmodists + Other Creative People',
    titleStr: 'References to Psalmodists + Other Creative People',
    filePath: require('./files/REFERENCES TO PSALMODISTS + OTHER CREATIVE PEOPLE.pdf'),
    alt: 'References to Psalmodists + Other Creative People',
    imageLarge: require('./images/large/references to psalmodists (Stone portrait)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/regular singing, old way of singing.jpg'),
    title: 'Regular Singing, Old Way of Singing',
    titleStr: 'Regular Singing, Old Way of Singing',
    filePath: require('./files/REGULAR SINGING, OLD WAY OF SINGING.pdf'),
    alt: 'Regular Singing, Old Way of Singing',
    imageLarge: require('./images/large/regular singing, old way of singing--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/seating of choir_singers (Brownson 1783).jpg'),
    title: 'Seating of Choir Singers, Other Choir-Related Matters',
    titleStr: 'Seating of Choir Singers, Other Choir-Related Matters',
    filePath: require('./files/SEATING OF CHOIR OR SINGERS, OTHER CHOIR-RELATED MATTERS.pdf'),
    alt: 'Seating of Choir Singers, Other Choir-Related Matters',
    imageLarge: require('./images/large/seating of choir_singers (Brownson 1783)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/singers in church (Brownson 1783).jpg'),
    title: 'Singers in Church',
    titleStr: 'Singers in Church',
    filePath: require('./files/SINGERS IN CHURCH.pdf'),
    alt: 'Singers in Church',
    imageLarge: require('./images/large/singers in church (Brownson 1783)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/singing leaders--choristers.jpg'),
    title: 'Singing Leaders--Choristers, Choir Directors',
    titleStr: 'Singing Leaders--Choristers, Choir Directors',
    filePath: require('./files/SINGING LEADERS--CHORISTERS, CHOIR DIRECTORS.pdf'),
    alt: 'Singing Leaders--Choristers, Choir Directors',
    imageLarge: require('./images/large/singing leaders--choristers--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/singing masters, singing schools (Read portrait).jpg'),
    title: 'Singing Masters, Singing Schools',
    titleStr: 'Singing Masters, Singing Schools',
    filePath: require('./files/SINGING MASTERS, SINGING SCHOOLS.pdf'),
    alt: 'Singing Masters, Singing Schools',
    imageLarge: require('./images/large/singing masters, singing schools (Read portrait)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/singing outside of church.jpg'),
    title: 'Singing Outside of Church',
    titleStr: 'Singing Outside of Church',
    filePath: require('./files/SINGING OUTSIDE OF CHURCH.pdf'),
    alt: 'Singing Outside of Church',
    imageLarge: require('./images/large/singing outside of church--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/systems of musical notation (RESIGNATION).jpg'),
    title: 'Systems of Musical Notation',
    titleStr: 'Systems of Musical Notation',
    filePath: require('./files/SYSTEMS OF MUSICAL NOTATION.pdf'),
    alt: 'Systems of Musical Notation',
    imageLarge: require('./images/large/systems of musical notation (RESIGNATION)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/text versions (Watts Psalms, 1799 ed.).jpg'),
    title: 'Text Versions, Psalms vs. Hymns',
    titleStr: 'Text Versions, Psalms vs. Hymns',
    filePath: require('./files/TEXT VERSIONS, PSALMS VS. HYMNS.pdf'),
    alt: 'Text Versions, Psalms vs. Hymns',
    imageLarge: require('./images/large/text versions (Watts Psalms, 1799 ed.)--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/ze bibliography of town + church histories.jpg'),
    title: 'Bibliography',
    titleStr: 'Bibliography',
    filePath: require('./files/ze bibliography.pdf'),
    alt: 'Bibliography',
    imageLarge: require('./images/large/ze bibliography of town + church histories--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/ze date sequence.jpg'),
    title: 'Date Sequencing',
    titleStr: 'Date Sequencing',
    filePath: require('./files/ze date sequencing.pdf'),
    alt: 'Date Sequencing',
    imageLarge: require('./images/large/ze date sequence--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/ze index of musicians.jpg'),
    title: 'Index of Musicians',
    titleStr: 'Index of Musicians',
    filePath: require('./files/ze index of musicians.pdf'),
    alt: 'Index of Musicians',
    imageLarge: require('./images/large/ze index of musicians--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/ze list of towns.jpg'),
    title: 'List of Towns',
    titleStr: 'List of Towns',
    filePath: require('./files/ze list of towns.pdf'),
    alt: 'List of Towns',
    imageLarge: require('./images/large/ze list of towns--large.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
  {
    image: require('./images/small/HISTORY OF PSALMODY CARD FILE.jpg'),
    title: 'History of Psalmody Card File',
    titleStr: 'History of Psalmody Card File',
    filePath: require('./files/HISTORY OF PSALMODY CARD FILE.pdf'),
    alt: 'HISTORY OF PSALMODY CARD FILE',
    imageLarge: require('./images/small/HISTORY OF PSALMODY CARD FILE.jpg'),
    // caption:
    //   'A Canon of 4 in 1 by William Billings--frontispiece, The New-England Psalm-Singer, [1770]',
  },
];
